// src/pages/AdminPage/components/DataTable.tsx
import { ReactNode } from "react";

export interface Column<T> {
  key: string;
  label: string;
  render: (row: T) => ReactNode;
  width?: string;
  hideOnMobile?: boolean;
}

interface DataTableProps<T> {
  columns: Column<T>[];
  data: T[];
  loading?: boolean;
  emptyMessage?: string;
  rowKey: (row: T) => string | number;
  minWidth?: number;
}

export default function DataTable<T>({
  columns,
  data,
  loading,
  emptyMessage = "Ma'lumot topilmadi",
  rowKey,
  minWidth = 500,
}: DataTableProps<T>) {
  return (
    <div
      style={{
        background: "#111827",
        border: "1px solid #1E2D45",
        borderRadius: 16,
        overflow: "hidden",
      }}>
      <div style={{ overflowX: "auto" }}>
        <table
          className="admin-table"
          style={{ width: "100%", borderCollapse: "collapse", minWidth }}>
          <thead>
            <tr style={{ borderBottom: "1px solid #1E2D45" }}>
              {columns.map((col) => (
                <th
                  key={col.key}
                  className={col.hideOnMobile ? "col-hide-mobile" : undefined}
                  style={{
                    padding: "12px 16px",
                    textAlign: "left",
                    color: "#475569",
                    fontSize: 11,
                    fontWeight: 700,
                    textTransform: "uppercase",
                    letterSpacing: 0.5,
                    width: col.width,
                  }}>
                  {col.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ?
              <tr>
                <td
                  colSpan={columns.length}
                  style={{
                    padding: 40,
                    textAlign: "center",
                    color: "#475569",
                  }}>
                  Yuklanmoqda...
                </td>
              </tr>
            : data.length === 0 ?
              <tr>
                <td
                  colSpan={columns.length}
                  style={{
                    padding: 40,
                    textAlign: "center",
                    color: "#475569",
                  }}>
                  {emptyMessage}
                </td>
              </tr>
            : data.map((row) => (
                <tr
                  key={rowKey(row)}
                  className="table-row"
                  style={{ borderBottom: "1px solid rgba(255,255,255,.04)" }}>
                  {columns.map((col) => (
                    <td
                      key={col.key}
                      className={col.hideOnMobile ? "col-hide-mobile" : undefined}
                      style={{ padding: "12px 16px" }}>
                      {col.render(row)}
                    </td>
                  ))}
                </tr>
              ))
            }
          </tbody>
        </table>
      </div>
    </div>
  );
}
